import { Injectable, Input } from '@angular/core';
import { Resource } from '../interfaces/resource';
import { MbscResource } from '@mobiscroll/angular';
@Injectable({
  providedIn: 'root'
})
export class FilterResourcesService {

  @Input() mySortedResources: Resource[] = [];
  filteredResources: MbscResource[] = this.mySortedResources;
  constructor() { }

  searchQuery: string = '';
  myFilters: { id: string; name: string; value: boolean, disabled: boolean }[] = [];
  teamFilters:any[] = [];
  interpreterFilters:any[]  = [];
  otherFilters:any[]  = [];


  filterResources( currentFilters: { [key: string]: boolean }, currentQuery: string) {

    this.filteredResources = this.mySortedResources
      .map((site) => {

        const children = (site.children ?? []).filter(
          (resource) =>
            (currentFilters[String(resource.id)] ?? true) &&
            (
              !currentQuery ||
              resource.name
                .toLowerCase()
                .includes(currentQuery.toLowerCase())
            )
        );

        return {
          ...site,
          children,
        };
      })
      .filter((site) => {

        return (
          site.children.length > 0 &&
          (currentFilters[String(site.id)] ?? true)
        );
      });

    this.filteredResources = [...this.filteredResources];
  }


  filterFlatResources(currentFilters: { [key: string]: boolean }, currentQuery: string) {
    this.filteredResources = this.mySortedResources.filter((resource: any) =>
      currentFilters[resource.id.toString()] &&
      (!currentQuery || resource.name.toLowerCase().includes(currentQuery.toLowerCase()))
    );
  }
}